<div [class]="toastClasses()" role="alert">
  <app-icons [icon]="defaultIcon()" svgClass="w-5 h-5 shrink-0" aria-hidden="true" />
  <span class="sr-only">{{ config().variant }}</span>
  <div class="ms-3 text-sm font-medium">
    {{ config().message }}
  </div>
  @if (config().options.closable) {
    <button type="button" [class]="buttonClasses()" (click)="onClose()" aria-label="Close">
      <span class="sr-only">Close</span>
      <app-icons icon="times" svgClass="w-4 h-4" />
    </button>
  }
</div>
